import { fluidClamp } from "@/shared";
import styled from "styled-components";

type RkpiWrapperProps = {
  $horizontalAlignment: string;
  $isBold: boolean;
  $color: string;
  $fontSize: number | string;
};

/**
 * The `fontSize` setting is not always a number: the elements library ships it
 * as a numeric string (`"72"`) and it can also be the keyword `"Auto"`, so
 * coerce before building the clamp instead of falling back to the inherited
 * (tiny) size for every string value.
 */
export function fluidFontSize(fontSize: number | string): string {
  const parsed =
    typeof fontSize === "number" ? fontSize : Number(String(fontSize).trim());
  if (!Number.isFinite(parsed) || parsed <= 0) return "inherit";
  return fluidClamp(parsed);
}

export const WrapperStyled = styled.div<{ $hasDynamicVar?: boolean }>`
  position: relative;
  width: 100%;
  justify-content: inherit;
  display: flex;
  .resize-controls {
    ${({ $hasDynamicVar }) => ($hasDynamicVar ? "outline-color: #ffb82e;" : "")}

    .counter {
      opacity: 1;
      visibility: visible;
      transform: translate(-50%, 0);
    }
    button.height {
      display: none;
    }
  }
`;

export const TextContainerStyled = styled.div<{
  $isBold: boolean;
  $isSmallWidth: boolean;
}>`
  position: relative;
  width: var(--entity-size);
  @media screen and (max-width: 576px) {
    width: ${({ $isSmallWidth }) =>
      $isSmallWidth ? "50%" : "var(--entity-size)"};
  }
  .rkpi__hidden {
    font-weight: ${({ $isBold }) => ($isBold ? "bold" : "inherit")};
    opacity: 0;
    visibility: "hidden";
    display: "block";
    pointer-events: "none";
  }
  .rkpi__number {
    font-size: inherit !important;
    position: absolute;
    top: 0;
  }

  .text-fit-container {
    & > div {
      display: flex !important;
      justify-content: center;
    }
  }
`;

export const RkpiWrapper = styled.div<RkpiWrapperProps>`
  &.rkpi {
    /* overflow: hidden; */
    justify-content: ${({ $horizontalAlignment }) =>
      $horizontalAlignment || "inherit"};
    ${({ $horizontalAlignment }) =>
      $horizontalAlignment === "start" &&
      `
        text-align:left;
    `};
    ${({ $horizontalAlignment }) =>
      $horizontalAlignment === "center" &&
      `
        text-align:center;
    `};
    ${({ $horizontalAlignment }) =>
      $horizontalAlignment === "end" &&
      `
        text-align:right;
    `};
    .rkpi__number {
      font-weight: ${({ $isBold }) => ($isBold ? "bold" : "inherit")};
      color: ${({ $color }) => $color || "var(--theme-color-1)"} !important;
      font-size: ${({ $fontSize }) => fluidFontSize($fontSize)};
      font-variant-numeric: tabular-nums;
    }
  }
`;
